import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import DoneIcon from '@material-ui/icons/Done';
import CancelIcon from '@material-ui/icons/Cancel';
import { handleSignUpAccept, handleSignUpDecline } from '../../api/alertsAPI';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%'
  },
  closeButton: {
    float: 'right',
    marginLeft: '15px',
  },
  acceptButton: {
    float: 'right',
  },
}));

export default function SignUpAlert({...props}) {
  const classes = useStyles();
  const {
    alert,
    removeAlert,
    snackBarSuccess,
    snackBarError,
    snackBarWarning } = props;
  const { firstName, lastName, email, user: userID, id } = alert;

  const handleAccept = () => {
    try {
      handleSignUpAccept(userID, id);
      snackBarSuccess(`${firstName} ${lastName} has been granted access!`);
      removeAlert();
    } catch (e) {
      console.error(e.message);
      snackBarError(`Unable to grant ${firstName} ${lastName} access. Please try again later.`);
    }
  }
  const handleDecline = () => {
    try {
      handleSignUpDecline(userID, id);
      snackBarWarning(`${firstName} ${lastName} has been declined access.`);
      removeAlert();
    } catch (e) {
      console.error(e.message);
      snackBarError(`Unable to decline ${firstName} ${lastName} access. Please try again later.`);
    }
  }
  return (
    <div>
      <MenuItem>
        <Typography 
          className={classes.fullWidth}
          component="p"
          noWrap
        >
          {firstName} {lastName} ({email})
          <IconButton 
            className={classes.acceptButton}
            color="primary"
            size="small"
            aria-label="accept"
            onClick={handleAccept}
          >
            <DoneIcon />
          </IconButton>
          <IconButton
            className={classes.closeButton}
            size="small"
            color="secondary" 
            aria-label="decline"
            onClick={handleDecline}
          >
            <CancelIcon />
          </IconButton>
        </Typography>
      </MenuItem>
    </div>
  )
}